import { Component, DestroyRef, inject, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import {
  LoadActivityStreamItems,
  ResetActivityStreamState,
  SetActivityStreamEntityType,
  SetActivityStreamLoadConfig
} from './data/activity-stream.actions';
import { ActivityStreamEntityType, ActivityStreamLoadConfig } from '@coin/shared/activity-stream/util';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { delay, switchMap } from 'rxjs/operators';

@Component({
  selector: 'coin-c-activity-stream',
  templateUrl: './activity-stream.component.html',
  styleUrls: ['./activity-stream.component.scss'],
  standalone: false
})
export class ActivityStreamComponent implements OnInit, OnDestroy, OnChanges {
  private store = inject(Store);
  private destroyRef = inject(DestroyRef);

  @Input({ required: true }) type!: ActivityStreamEntityType;
  @Input({ required: true }) loadConfig!: ActivityStreamLoadConfig;
  @Input() reload$?: Observable<void>;
  @Input() showFilters = true;

  ngOnInit(): void {
    this.listenToReload();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.loadConfig?.previousValue !== changes.loadConfig?.currentValue) {
      this.setupState();
    }
  }

  private setupState(): void {
    this.store
      .dispatch(new SetActivityStreamEntityType(this.type))
      .pipe(
        switchMap(() => this.store.dispatch(new SetActivityStreamLoadConfig(this.loadConfig))),
        switchMap(() => this.store.dispatch(new LoadActivityStreamItems(true))),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe();
  }

  private listenToReload(): void {
    if (this.reload$) {
      // wait 1s for changes to process in the backend in order to become visible in the stream
      this.reload$
        .pipe(delay(1_000))
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe(() => this.store.dispatch(new LoadActivityStreamItems(true)));
    }
  }

  ngOnDestroy(): void {
    this.store.dispatch(new ResetActivityStreamState());
  }
}
